// src/project/data/triggers/finishDelivery.js
import { buildActionUrl, RIDER_ENDPOINTS } from '../config/apiConfig'

export default {
  postUrl(payload) {
    const itemData = payload.order || payload.delivery || payload
    const isPackage = itemData.type === 'package'

    if (isPackage) {
      return buildActionUrl(RIDER_ENDPOINTS.PACKAGE_STATUS)
    }

    const deliveryId = payload.deliveryId || itemData.id
    if (!deliveryId) throw new Error('deliveryId requis pour terminer une livraison')
    // Statut "delivered" pour finaliser la livraison
    return buildActionUrl(RIDER_ENDPOINTS.ORDER_STATUS) + '&status=delivered'
  },
  format(payload) {
    const itemData = payload.order || payload.delivery || payload
    const isPackage = itemData.type === 'package'
    // V3 : position de livraison optionnelle dans le body
    const lat = payload.pos?.lat ?? payload.lat ?? null
    const lng = payload.pos?.lng ?? payload.lng ?? null
    const deliveryId = payload.deliveryId || itemData.id

    const body = {}
    
    if (isPackage) {
      body.packageId = deliveryId
      body.newStatus = 'delivered'
    } else {
      // Pour l'ordre, certains backends V3 veulent l'ID dans le body, et newStatus
      body.orderId = deliveryId
      body.newStatus = 'delivered'
    }

    body.metadata = {}
    if (lat !== null) body.metadata.riderLat = lat
    if (lng !== null) body.metadata.riderLng = lng
    return body
  },
  parse(raw = {}) {
    // Réponse V3 attendue :
    // { statusCode: 200, message: "Order status updated", data: { ...orderData } }
    if (raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Le serveur semble inaccessible',
        data: raw?.data || null,
      }
    }
    return {
      statusCode: 200,
      message: raw?.message || 'Livraison terminée',
      data: {
        saved: true,
        delivery: raw?.data || null,
      },
    }
  },
}
